import Vuex from "vuex";
import productStore from "./ProductStore";
import characteristicsStore from "./CharacteristicsStore";
import templateStore from "./TemplatesStore";
import reportStore from "./ReportStore";
import { fileStore } from "./FileStore";
import userStore from "./UserStore";

export const store = new Vuex.Store({
  modules: {
    productStore: productStore,
    characteristicsStore,
    templateStore,
    reportStore: reportStore as any,
    userStore,
    fileStore
  }
});
